import axios from 'axios';
import { updateUrlGetParams } from '@/helpers/url';
import WebApi from '../WebApi';
class EventsWebApi extends WebApi {
    async getServicePointAdvisors({ page = 1, last_name = '' }) {
        const url = updateUrlGetParams(`${this.urlPrefix}/service_point_advisors`, {
            'pagination[per_page]': 25,
            'pagination[page]': page,
            ...(last_name && { last_name }),
        });
        const { data } = await axios.get(decodeURI(url));
        return data;
    }
    ;
    async getShiftsSlots({ from, sp_id, location, advisor_id }) {
        const url = updateUrlGetParams(`${this.urlPrefix}/service_point_shifts/dates`, {
            'dt': from,
            sp_id,
            ...(advisor_id && { advisor_id }),
        });
        const { data } = await axios.get(decodeURI(url));
        return data;
    }
    ;
    async getShiftsSlotsForDate({ dt, from, to, sp_id, page = 1, advisor_id }) {
        const url = updateUrlGetParams(`${this.urlPrefix}/service_point_shifts`, {
            'pagination[per_page]': 31,
            'pagination[page]': page,
            ...(dt && { dt }),
            ...(from && { from }),
            ...(to && { to }),
            sp_id,
            ...(advisor_id && { advisor_id }),
        });
        const { data } = await axios.get(decodeURI(url));
        return data;
    }
    ;
    async getReservedSlots({ from, to, user_id, page = 1, location }) {
        const url = updateUrlGetParams(`${this.urlPrefix}/reserved_slots`, {
            'pagination[per_page]': 31,
            'pagination[page]': page,
            to,
            from,
            user_id,
            location,
        });
        const { data } = await axios.get(decodeURI(url));
        return data;
    }
    ;
    async getUnavailabilities({ from, to, user_id, page = 1 }) {
        const url = updateUrlGetParams(`${this.urlPrefix}/unavailabilities`, {
            'pagination[per_page]': 31,
            'pagination[page]': page,
            to,
            from,
            user_id,
        });
        const { data } = await axios.get(decodeURI(url));
        return data;
    }
    ;
    async getAvailabilities({ from, to, user_id, page = 1 }) {
        const url = updateUrlGetParams(`${this.urlPrefix}/flexible_dates`, {
            'pagination[per_page]': 31,
            'pagination[page]': page,
            to,
            from,
            user_id,
        });
        const { data } = await axios.get(decodeURI(url));
        return data;
    }
    ;
    async getEvent(id) {
        const { data } = await axios.get(`${this.urlPrefix}/events/${id}`);
        return data;
    }
    ;
    async createEvent(payload) {
        const url = payload.origin === `unavailability` ? `/events` : `/reserved_slots`;
        const { data } = await axios.post(`${this.urlPrefix}${url}`, { 'event': payload });
        return data;
    }
    ;
    async createAvailabilityEvent(payload) {
        const { data } = await axios.post(`${this.urlPrefix}/flexible_dates`, { 'flexible_date': payload });
        return data;
    }
    ;
    async createShiftEvent(shift) {
        const { data } = await axios.post(`${this.urlPrefix}/shifts`, { shift });
        return data;
    }
    ;
    async updateShiftEvent(shift, id, scope) {
        const { data } = await axios.put(`${this.urlPrefix}/shifts/${id}`, {
            shift: {
                ...shift,
                ...(scope && { scope }),
            }
        });
        return data;
    }
    ;
    async getFullShiftData(id) {
        const { data } = await axios.get(`${this.urlPrefix}/shifts/${id}`);
        return data.shift;
    }
    ;
    async getFullShiftRecurrenceData(id) {
        const { data } = await axios.get(`${this.urlPrefix}/recurrences/${id}`);
        return data.recurrence;
    }
    ;
    async deleteFullShiftData(id, scope = null) {
        const { data } = await axios.delete(updateUrlGetParams(`${this.urlPrefix}/shifts/${id}`, {
            ...(scope && { scope }),
        }));
        return data;
    }
    ;
    async updateEvent({ payload, id }) {
        const { data } = await axios.put(`${this.urlPrefix}/events/${id}`, {
            'event': payload,
        });
        return data;
    }
    ;
    async deleteEvent(id) {
        const { data } = await axios.delete(`${this.urlPrefix}/events/${id}`);
        return data;
    }
    ;
    async deleteCalendarInstance(id, future) {
        const params = {};
        if (future) {
            params.scope = `future`;
        }
        const { data } = await axios.delete(updateUrlGetParams(`${this.urlPrefix}/calendar_instances/${id}`, params));
        return data;
    }
    ;
    async deleteCalendarAvailabilityInstance(id) {
        const { data } = await axios.delete(`${this.urlPrefix}/flexible_dates/${id}`);
        return data;
    }
    ;
    async deleteCalendarAvailabilities(user_id) {
        const { data } = await axios.post(`${this.urlPrefix}/flexible_dates/bulk_delete`, { user_id });
        return data;
    }
    ;
}
const eventsWebApi = new EventsWebApi();
export { eventsWebApi as EventsWebApi, };
